var map = {
	"./IT_goal.png": 958974,
	"./capex.png": 647419,
	"./communication_results.png": 114031,
	"./critical_services.png": 883495,
	"./kpi.png": 639579,
	"./opex.png": 540816,
	"./priority.png": 452655,
	"./risk_mapping.png": 432944,
	"./strategic_alignment.png": 936000,
	"./strategic_partners.png": 809102
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 28106;